'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const RelatedKeys = require('common/domain/value/related-keys');
const GroupRoleRepository = require('common/domain/repository/group-role');
const ProjectRoleRepository = require('common/domain/repository/project-role');
// const ModalView = require('common/ui/view/modal/index');
// const MentionView = require('common/ui/view/mention');
const PopoverView = require('common/ui/view/popover');
// const UserDropdownItemTemplate = require('system/ui/template/markdown/user-dropdown-item.hbs');
const CommentAddView = require('communication/ui/comment/view/add');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const MemberListView = require('balus/ui/view/timeline/member-list');
const AdditionalView = require('balus/ui/view/additional/index');
const RecommendView = require('balus/ui/view/additional/recommend/index');
const Template = require('balus/ui/template/timeline/comment.hbs');
const MentionTemplate = require('balus/ui/template/timeline/mention.hbs');
const Dialog = require('common/util/dialog');
// const OpenURI = require('data/ui/view/content/open-uri');

const MemberCollection = Backbone.Collection.extend({
    comparator: function(member) {
        return member.getUser().getName().toLowerCase();
    }
});

const MentionItemView = Mn.View.extend({
    tagName: 'span',
    className: 'timeline-mention-item',
    template: MentionTemplate,
    triggers: {
        'click .timeline-mention-item-remove': 'remove:mention'
    },
    templateContext: {
        edit: true
    }
});

const MentionListView = Mn.CollectionView.extend({
    childView: MentionItemView,
    childViewTriggers: {
        'remove:mention': 'remove:mention'
    }
});

module.exports = Mn.View.extend({
    template: Template,
    className: 'timeline-comment',
    regions: {
        comment: '.timeline-comment-add',
        memberList: '.member-list',
        mentionList: '.timeline-mention-list',
        additional: '.additional',
        selector: '.selector',
        recommend: '.recommend-wrapper'
    },
    ui: {
        createBtn: 'button.comment',
        closeBtn: 'button.close-comment',
        showMemberList: '.member-list-button',
    },
    events: {
        'click @ui.createBtn': 'comment',
        'click @ui.closeBtn': 'close',
        'click @ui.showMemberList': 'showMembers',
    },
    childViewEvents: {
        'focus': 'open',
        'close': 'close',
        'comment': 'comment',
        'reply': 'onReply',
        'removeReply': 'removeClassReply',
        'hide': 'onSelectedMembers',
        'show:group:members': 'showGroupMembers',
        'select:project:members': 'onSelectAllProjectMembers',
        'remove:mention': 'onRemoveMention',
        'paste:file': 'onPasteFile',
        'enable:send:button': 'enableSendButton',
        'disable:send:button': 'disableSendButton',
        'blur': 'commentDraftSave',
        'add:relatedKey': 'commentDraftSave',
        'remove:relatedKey': 'commentDraftSave',
        'add:content:comment': 'onAddContentToComment'
    },
    childViewTriggers: {
        'comment:form:resized': 'comment:form:resized',
        'add:content': 'add:content'
    },

    initialize: function() {
        const context = this.getOption('context');
        const originalGroupMembers = context.getGroup().getMembers().models;
        const originalProjectMembers = context.getProject().getMembers().models;

        // Group/Projectのメンバー一覧から宛先候補表示用に同じパラメータを持った新しいオブジェクトを生成する。
        // Group/Projectから取得可能なメンバーオブジェクトは、他のViewにもBindされているので、影響範囲を限定するため。
        this._groupMembers = new MemberCollection(_.map(originalGroupMembers, m => m.clone()));
        this._projectMembers = new MemberCollection(_.map(originalProjectMembers, m => {
            return m.clone().set({ 'isProjectMember': true });
        }));
        this._groupMembers.add(this._projectMembers.models);
        this._mentions = new Backbone.Collection();
    },

    onRender: function() {
        const context = this.getOption('context');
        const draftComment = this.getOption('draftComment');
        const user = context.getUser();
        const group = context.getGroup();

        if(group.isMember(user ? user.id : null)) {
            this.showChildView('comment', new CommentAddView({
                rows: 1,
                maxRows: 10,
                hideEditorTab: 1,
                context: context,
                tempBody: !_.isEmpty(draftComment) ? draftComment.getBody() : ''
            }));
        }

        this.showChildView('mentionList', new MentionListView({
            collection: this._mentions
        }));

        this.showChildView('additional', new AdditionalView({
            relatedKeys: !_.isEmpty(draftComment) ? new RelatedKeys(draftComment.get('relatedKeys')) : new RelatedKeys([]),
            context: context,
            isEditable: true
        }));

        this.showChildView('recommend', new RecommendView({
            context: context
        }));

        this.showChildView('selector', this.getChildView('additional').getSelectorView());

        if(_.isEmpty(draftComment)) {
            this.initializeMentions();
            this.disableSendButton();
        } else {
            if( draftComment.isNotEmpty() ) {
                const tempUsers = context.getGroup().getMembers().models
                    .filter((user) => {
                        return _.contains(draftComment.getMentionTo(), user.get('id').toString());
                    });
                _.each(tempUsers, (member) => {
                    this._mentions.add(member.get('user'));
                });
                if (draftComment.getReplyTo()) {
                    this.setReplyTo(draftComment.getReplyTo());
                }
                this.open();
            }
        }
    },

    // FIXME: コメント入力欄で `@` 入力で宛先候補を保管する機能を一旦無効化する
    // onDomRefresh: function() {
    //     const members = this.getOption('context').getGroup().getMembers();
    //     const _mentions = this._mentions;
    //
    //     new MentionView({
    //         el: this.$('textarea.inline-writer'),
    //         topOffset: -80,
    //         itemView: MentionView.DropdownItemView.extend({
    //             template: UserDropdownItemTemplate,
    //             active: function () {
    //                 this.$el.addClass('active');
    //             },
    //             templateContext: function() {
    //                 return this.model.getUser().toJSON();
    //             }
    //         }),
    //         matcher: [
    //             new RegExp('@(\\S*)$')
    //         ],
    //         find: function (query) {
    //             const maxDropdownLen = 10;
    //             // 先頭の @ を取り除く
    //             query = query.slice(1).toLowerCase();
    //             return members.findByQuery(query).slice(0, maxDropdownLen);
    //         },
    //         update: function (model) {
    //             _mentions.add(model.getUser());
    //             return '';
    //         }
    //     });
    // },

    commentDraftSave: function() {
        const comment = this.uniteComment();
        comment.replyTo = this.getChildView('comment').getReplyTo();
        this.triggerMethod('comment:sent:draft', comment);
    },

    uniteComment: function() {
        const comment = this.getChildView('comment').getComment();
        comment.userIDs = this.getRelatedUserIDs();
        comment.relatedKeys = this.getRelatedKeys();
        return comment;
    },

    comment: function() {
        this.disableSendButton();
        const comment = this.uniteComment();
        const hasMention = this._mentions.length > 0;
        const isReply = comment.replyTo != null;

        if(hasMention || isReply) {
            this.triggerMethod('comment:sent', comment);
        } else {
            Dialog.confirm({
                text: i18n.t('notify.comment-confirm'),
                okCallback: () => {
                    this.triggerMethod('comment:sent', comment);
                },
                cancelCallback: () => {
                    this.enableSendButton();
                }
            });
        }
    },

    onCommentTask: function(comment, task) {
        comment.userIDs = this.getRelatedUserIDs();
        comment.relatedKeys = this.getRelatedKeys();

        this.triggerMethod('comment:task:sent', comment, task);
    },

    getRelatedUserIDs: function() {
        return this._mentions.map(m => '' + m.id);
    },

    getRelatedKeys: function() {
        return this.getChildView('additional').getRelatedKeys();
    },

    onRemoveMention: function(child) {
        this._mentions.remove(child.model);
        this.commentDraftSave();
    },

    onRemoveComment: function(child) {
        this._contents.remove(child.model);
    },

    open: function() {
        const context = this.getOption('context');
        this.removeClassReply();
        this.$el.addClass('is-open');

        const minRows = 5;
        const rows = this.getChildView('comment').getCommentRows();
        if(rows < minRows || !rows) {
            this.getChildView('comment').updateRows(minRows);
        } else {
            this.getChildView('comment').adjustRows();
        }

        // アクションのタイムラインでコメント編集を始めたら、
        // アクションに関連付けられている全ての ActionWork Content を取得する
        if(context.get().key.kind == 'Action') {
            const action = context.get();
            const project = action.getProject();
            ContentActionWorkRepository.find(project)
                .fetchAllActionWorkContentsByAction(action);
        }
        this.getChildView('recommend').open();

        this.triggerMethod('comment:form:resized');
    },

    close: function() {
        this.$el.removeClass('is-open');
        if(this.getChildView('comment').ui.replyTo.html()){
            this.$el.addClass('avail-reply');
        }
        this.getChildView('comment').updateRows(1);

        this.triggerMethod('comment:form:resized');
    },

    setReplyTo: function(replyTo) {
        this.getChildView('comment').setReplyTo(replyTo);
        this._mentions.reset([]);
        this.open();
    },

    setReplyTask: function(task) {
        this.getChildView('comment').setReplyTask(task);
        this.open();
    },

    removeReplyTo: function() {
        this.getChildView('comment').removeReplyTo();
    },

    removeClassReply: function() {
        this.$el.removeClass('avail-reply');
    },

    removeReplyTask: function() {
        this.getChildView('comment').removeReplyTask();
    },

    cleanup: function() {
        this.getChildView('comment').cleanup();
        this.getChildView('additional').cleanup();
        this.initializeMentions();
    },

    commentDisabled: function() {
        this.getChildView('comment').disabled();
    },

    commentEnabled: function() {
        this.getChildView('comment').enabled();
        this.getChildView('recommend').cleanup();
    },

    onSelectedMembers: function() {
        const memberListView = this.getChildView('memberList').options.view;
        const members = memberListView.getActiveMembers();
        this._mentions.reset([]);
        _.each(members, (member) => { this._mentions.add(member.getUser()); });
        this.commentDraftSave();
        this.hideMembers();
    },

    onSelectAllProjectMembers: function() {
        const project = this.getOption('context').getProject();
        project.getMembers().each((member) => {
            // 「プロジェクトの全員」の対象となるのは、権限が「マネージャ (owner)」または「プレイヤー (player)」 の場合
            if (member.isOwner() || member.isPlayer()) {
                this._mentions.add(member.getUser());
            }
        });
        this.commentDraftSave();
        this.hideMembers();
    },

    initializeMentions: function() {
        this._mentions.reset([]);

        // アクションのタイムラインではアクションの担当者を宛先に追加する
        const context = this.getOption('context');
        if(context.get().key.kind == 'Action') {
            const action = context.get();
            _.each(action.getAssignees(), a => {
                this._mentions.add(a);
            });
        }
    },

    showMembers: function() {
        const context = this.getOption('context');
        const projectMembers = this._activateMentionedMembers(
            new MemberCollection(this._projectMembers.models)
        );
        const groupMembers = this._activateMentionedMembers(
            new MemberCollection(this._groupMembers.models)
        );

        // プロジェクトメンバーにすでに選択されているグループメンバーを追加する
        const mentionedGroupMembers = new MemberCollection(groupMembers.filter(member => {
            return member.get('active');
        }));
        projectMembers.add(mentionedGroupMembers.models);

        Promise.all([
            ProjectRoleRepository.find(context.getGroup()).fetchRoles(),
            this._getProjectAccessibleMembers()
        ])
            .then(values => {
                const projectRoles = values[0];
                const accessibleMembers = values[1];

                const memberListView = new MemberListView({
                    context: context,
                    model: this.model,
                    collection: projectMembers,
                    projectRoles: projectRoles,
                    moreMembers: accessibleMembers.length > projectMembers.length,
                    filter: function(item) {
                        return !item.isSuspended();
                    }
                });

                const popoverView = new PopoverView({
                    childViewTriggers: {
                        'show:group:members': 'show:group:members',
                        'select:project:members': 'select:project:members'
                    },
                    view: memberListView,
                    width: 320,
                    maxHeight: this.$el.outerHeight(),
                    placement: 'top',
                    show: true
                });

                this.showChildView('memberList', popoverView);
            });
    },

    showGroupMembers: function() {
        this._getProjectAccessibleMembers()
            .then(members => {
                const memberListView = this.getChildView('memberList').options.view;
                memberListView.updateMembers(members.models);
            });
    },

    _activateMentionedMembers: function(members) {
        const mentionedUserIDs = this.getRelatedUserIDs().map(id => Number(id));

        _.each(members.models, member => {
            if (_.contains(mentionedUserIDs, member.get('user').id)) {
                member.set({ 'active': true });
            } else {
                member.set({ 'active': false });
            }
        });

        return members;
    },

    // プロジェクトを閲覧する権限があるメンバーを返す。
    // プロジェクトを閲覧する権限がない = プロジェクトに参加していない、かつ、グループロールがゲスト
    _getProjectAccessibleMembers: function() {
        const context = this.getOption('context');
        const groupMembers = this._activateMentionedMembers(
            new MemberCollection(this._groupMembers.models)
        );

        return new Promise((resolve, reject) => {
            GroupRoleRepository.find(context.getGroup()).fetchRoles()
                .then(groupRoles => {
                    const members = new MemberCollection(groupMembers.filter(member => {
                        const groupRole = groupRoles.get(member.getRole());
                        return member.get('isProjectMember') || groupRole.id != 'guest';
                    }));
                    resolve(members);
                });
        });
    },

    hideMembers: function() {
        this.getRegion('memberList').empty();
        this.$('textarea.inline-writer').focus();
    },

    onPasteFile: function(file) {
        this.getChildView('selector').showContentAddModal(file);
    },

    addRecord: function(record) {
        this.getChildView('additional').addRelatedKeys(record.key);
    },

    addRelation: function(relation) {
        this.getChildView('additional').addRelatedKeys(relation.key);
    },

    addContent: function(content) {
        this.getChildView('additional').addRelatedKeys([content.key, content.getLatestVersion().key]);
    },

    addModel: function(model) {
        this.getChildView('additional').addRelatedKeys(model.key);
    },

    enableSendButton: function() {
        this.ui.createBtn.attr('disabled', null);
    },

    disableSendButton: function() {
        this.ui.createBtn.attr('disabled', 'disabled');
    },

    onAddContentToComment: function(child) {
        this.getChildView('comment').addContentToComment(child);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/timeline/comment.js